import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import SideBar from "@/components/SideBar.vue";
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import router from "@/router";
import { useUserStore } from "@/store/user";
import { useCoachStore } from "@/store/coach";
import { useScroll, useEventBus } from "@vueuse/core";
import { useGameplaneStore } from "@/store/gameplan";
import { useSupportChat } from "@/composables/useSupportChat";
import { useManageSubscription } from "@/composables/useManageSubscription";
import { useMigrateBanner } from "@/composables/useMigrateBanner";
import MigrateBanner from "@/components/MigrateBanner.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props, { expose }) {
  expose();

_useCssVars(_ctx => ({
  "5a4f6d3a": (_unref(migrateBannerHeight))
}))

const userStore = useUserStore();
const coachStore = useCoachStore();
const gameplanStore = useGameplaneStore();
const { isCoach } = useSupportChat();
const { isActiveMainSubs } = useManageSubscription();
const { migrateBannerHeight } = useMigrateBanner();
const refScrollBlock = ref<HTMLElement | null>();
const bus = useEventBus<string>("scrollToSavedPosition");
const { y, arrivedState } = useScroll(refScrollBlock, {
  behavior: "smooth",
});

const hideMobileSidebar = computed(() => {
  return router.currentRoute.value.meta.hideMobileSidebar;
});

onMounted(() => {
  if (userStore.accessToken) {
    gameplanStore.getCurrentCourse();
  }
});

router.afterEach(() => {
  setTimeout(() => {
    if (refScrollBlock.value) {
      y.value = 0;
    }
  }, 200);
});

router.beforeEach((to, from, next) => {
  if (to.name !== from.name && to.name !== userStore.scrollPageData.routeName) {
    userStore.scrollPageData.scroll = y.value;
    userStore.scrollPageData.routeName = router.currentRoute.value
      ?.name as string;
  }

  next();
});

const scrollToSavedPosition = () => {
  if (
    userStore.scrollPageData.scroll &&
    userStore.scrollPageData.routeName ===
      router.currentRoute.value?.name?.toString()
  ) {
    setTimeout(() => {
      y.value = userStore.scrollPageData.scroll;
      userStore.scrollPageData = {
        scroll: 0,
        routeName: "",
        pageSkip: 0,
        activeAccordionItem: -1,
      };
    }, 500);
  }
};

bus.on(scrollToSavedPosition);

onBeforeUnmount(() => {
  bus.off(scrollToSavedPosition);
});

const __returned__ = { userStore, coachStore, gameplanStore, isCoach, isActiveMainSubs, migrateBannerHeight, refScrollBlock, bus, y, arrivedState, hideMobileSidebar, scrollToSavedPosition, SideBar, computed, onBeforeUnmount, onMounted, ref, router, useUserStore, useCoachStore, useScroll, useEventBus, useGameplaneStore, useSupportChat, useManageSubscription, useMigrateBanner, MigrateBanner }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})